/** @format */

import styled from 'styled-components';

const StyledTagText = styled.span``;

export default StyledTagText;
